<button type="button" class="btn btn-primary" (click)="openModalWithComponent()">Create modal with component</button>
